(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  class FirstPurchasePromo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.copyButton = this.querySelector('[data-copy-coupon]');
      this.copyLabel = this.querySelector('[data-coupon-label]');
      this.copyStatus = this.querySelector('[data-copy-status]');
      this.closeButton = this.querySelector('[data-close-promo]');
      this.couponCode = this.copyButton?.dataset.code || '';
      this.originalLabel = this.copyLabel?.textContent || this.couponCode;

      try {
        if (!window.Shopify?.designMode && sessionStorage.getItem(this.dataset.storageKey) === 'dismissed') {
          this.hidden = true;
        }
      } catch (error) {}

      this.copyButton?.addEventListener('click', () => this.copyCoupon());
      this.closeButton?.addEventListener('click', () => this.dismiss());
    }

    async copyCoupon() {
      if (!this.couponCode) return;

      try {
        await navigator.clipboard.writeText(this.couponCode);
      } catch (error) {
        const textarea = document.createElement('textarea');
        textarea.value = this.couponCode;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
      }

      if (this.copyLabel) this.copyLabel.textContent = '¡Copiado!';
      if (this.copyStatus) this.copyStatus.textContent = `Cupón ${this.couponCode} copiado`;
      this.copyButton?.classList.add('is-copied');

      window.clearTimeout(this.feedbackTimer);
      this.feedbackTimer = window.setTimeout(() => {
        if (this.copyLabel) this.copyLabel.textContent = this.originalLabel;
        if (this.copyStatus) this.copyStatus.textContent = '';
        this.copyButton?.classList.remove('is-copied');
      }, 1800);
    }

    dismiss() {
      this.hidden = true;
      try {
        sessionStorage.setItem(this.dataset.storageKey, 'dismissed');
      } catch (error) {}
    }

    disconnectedCallback() {
      window.clearTimeout(this.feedbackTimer);
    }
  }

  if (!customElements.get('first-purchase-promo')) {
    customElements.define('first-purchase-promo', FirstPurchasePromo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
